import React, { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { loginRequest } from '../../auth/msalConfig';
import { FiLogIn } from 'react-icons/fi';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { instance } = useMsal();

  const handleLogin = useCallback(() => {
    instance.loginRedirect(loginRequest);
  }, [instance]);

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">AK</div>
        <h1 className="login-title">{t('login.title')}</h1>
        <p className="login-subtitle">{t('login.subtitle')}</p>
        <button className="login-btn" onClick={handleLogin}>
          <FiLogIn size={18} />
          {t('login.loginButton')}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
